<template>
  <section class="calculator-module">
    <div class="module-header">
      <h2>{{ t('waterManagement.title') }}</h2>
      <span class="toggle-icon">▼</span>
    </div>
    <div class="module-content">
      <div class="calculator-intro">
        <h3>💧 {{ t('waterManagement.title') }}</h3>
        <p>{{ t('waterManagement.subtitle') }}</p>
      </div>
      
      <div class="calculator-tabs">
       <button
         class="tab-btn"
         :class="{ active: activeTab === 'volume' }"
         @click="activeTab = 'volume'"
       >
         {{ t('waterManagement.tabs.volume') }}
       </button>
       <button
         class="tab-btn"
         :class="{ active: activeTab === 'change' }"
         @click="activeTab = 'change'"
       >
         {{ t('waterManagement.tabs.change') }}
       </button>
     </div>
      
      <!-- 水体体积计算 -->
      <div v-if="activeTab === 'volume'" class="calculator-form">
        <div class="form-section">
          <h4>{{ t('waterManagement.volume.tankDimensions') }}</h4>
          <div class="form-group">
            <label for="tank_length">{{ t('waterManagement.volume.lengthCm') }}</label>
            <input
              type="number"
              id="tank_length"
              v-model="volumeData.length"
              class="form-control"
              :placeholder="t('waterManagement.volume.placeholders.lengthCm').value"
              step="1"
              min="10"
              max="500"
            >
          </div>
          
          <div class="form-group">
            <label for="tank_width">{{ t('waterManagement.volume.widthCm') }}</label>
            <input
              type="number"
              id="tank_width"
              v-model="volumeData.width"
              class="form-control"
              :placeholder="t('waterManagement.volume.placeholders.widthCm').value"
              step="1"
              min="10"
              max="300"
            >
          </div>
          
          <div class="form-group">
            <label for="tank_height">{{ t('waterManagement.volume.heightCm') }}</label>
            <input
              type="number"
              id="tank_height"
              v-model="volumeData.height"
              class="form-control"
              :placeholder="t('waterManagement.volume.placeholders.heightCm').value"
              step="1"
              min="10"
              max="200"
            >
          </div>
          
          <div class="form-group">
            <label for="water_level">{{ t('waterManagement.volume.waterLevelCm') }}</label>
            <input
              type="number"
              id="water_level"
              v-model="volumeData.waterLevel"
              class="form-control"
              :placeholder="t('waterManagement.volume.placeholders.waterLevelCm').value"
              step="1"
              min="10"
              max="200"
            >
          </div>
        </div>
        
        <div class="form-section">
          <h4>{{ t('waterManagement.volume.sumpSettings') }}</h4>
          <div class="form-group">
            <label class="checkbox-label">
              <input
                type="checkbox"
                v-model="volumeData.hasSump"
              >
              <span class="checkbox-custom"></span>
              {{ t('waterManagement.volume.hasSump') }}
            </label>
          </div>
          
          <div v-if="volumeData.hasSump" class="sump-section">
            <div class="form-group">
              <label for="sump_length">{{ t('waterManagement.volume.sumpLength') }}</label>
              <input
                type="number"
                id="sump_length"
                v-model="volumeData.sumpLength"
                class="form-control"
                :placeholder="t('waterManagement.volume.placeholders.sumpLength').value"
                step="1"
                min="10"
                max="200"
              >
            </div>
            
            <div class="form-group">
              <label for="sump_width">{{ t('waterManagement.volume.sumpWidth') }}</label>
              <input
                type="number"
                id="sump_width"
                v-model="volumeData.sumpWidth"
                class="form-control"
                :placeholder="t('waterManagement.volume.placeholders.sumpWidth').value"
                step="1"
                min="10"
                max="150"
              >
            </div>
            
            <div class="form-group">
              <label for="sump_height">{{ t('waterManagement.volume.sumpHeight') }}</label>
              <input
                type="number"
                id="sump_height"
                v-model="volumeData.sumpHeight"
                class="form-control"
                :placeholder="t('waterManagement.volume.placeholders.sumpHeight').value"
                step="1"
                min="10"
                max="100"
              >
            </div>
            
            <div class="form-group">
              <label for="sump_water_level">{{ t('waterManagement.volume.sumpWaterLevel') }}</label>
              <input
                type="number"
                id="sump_water_level"
                v-model="volumeData.sumpWaterLevel"
                class="form-control"
                :placeholder="t('waterManagement.volume.placeholders.sumpWaterLevel').value"
                step="1"
                min="10"
                max="100"
              >
            </div>
          </div>
        </div>
        
        <div class="form-section">
          <h4>{{ t('waterManagement.volume.otherParams') }}</h4>
          <div class="form-group">
            <label for="rock_volume">{{ t('waterManagement.volume.rockVolume') }}</label>
            <input
              type="number"
              id="rock_volume"
              v-model="volumeData.rockVolume"
              class="form-control"
              :placeholder="t('waterManagement.volume.placeholders.rockVolume').value"
              step="1"
              min="0"
              max="1000"
            >
          </div>
          
          <div class="form-group">
            <label for="sand_volume">{{ t('waterManagement.volume.sandVolume') }}</label>
            <input
              type="number"
              id="sand_volume"
              v-model="volumeData.sandVolume"
              class="form-control"
              :placeholder="t('waterManagement.volume.placeholders.sandVolume').value"
              step="1"
              min="0"
              max="1000"
            >
          </div>
          
          <div class="form-group">
            <label for="equipment_volume">{{ t('waterManagement.volume.equipmentVolume') }}</label>
            <input
              type="number"
              id="equipment_volume"
              v-model="volumeData.equipmentVolume"
              class="form-control"
              :placeholder="t('waterManagement.volume.placeholders.equipmentVolume').value"
              step="1"
              min="0"
              max="500"
            >
          </div>
        </div>
        
        <button
          class="calculate-btn"
          @click="calculateVolume"
          :disabled="!canCalculateVolume"
        >
          {{ t('waterManagement.volume.calculateVolume') }}
        </button>
      </div>
      
      <!-- 换水计算 -->
      <div v-if="activeTab === 'change'" class="calculator-form">
        <div class="form-section">
          <h4>{{ t('waterManagement.change.params') }}</h4>
          <div class="form-group">
            <label for="total_volume">{{ t('waterManagement.change.totalVolume') }}</label>
            <input
              type="number"
              id="total_volume"
              v-model="changeData.totalVolume"
              class="form-control"
              :placeholder="t('waterManagement.volume.placeholders.totalVolume').value"
              step="1"
              min="1"
              max="10000"
            >
          </div>
          
          <div class="form-group">
            <label for="current_salinity">{{ t('waterManagement.change.currentSalinity') }}</label>
            <input
              type="number"
              id="current_salinity"
              v-model="changeData.currentSalinity"
              class="form-control"
              :placeholder="t('waterManagement.volume.placeholders.currentSalinity').value"
              step="0.001"
              min="1.015"
              max="1.040"
            >
          </div>
          
          <div class="form-group">
            <label for="target_salinity">{{ t('waterManagement.change.targetSalinity') }}</label>
            <input
              type="number"
              id="target_salinity"
              v-model="changeData.targetSalinity"
              class="form-control"
              :placeholder="t('waterManagement.volume.placeholders.targetSalinity').value"
              step="0.001"
              min="1.015"
              max="1.040"
            >
          </div>
          
          <div class="form-group">
            <label for="change_percentage">{{ t('waterManagement.change.changePercentage') }}</label>
            <input
              type="number"
              id="change_percentage"
              v-model="changeData.changePercentage"
              class="form-control"
              :placeholder="t('waterManagement.volume.placeholders.changePercentage').value"
              step="1"
              min="1"
              max="100"
            >
          </div>
          
          <div class="form-group">
            <label for="salt_mix">{{ t('waterManagement.change.saltBrand') }}</label>
            <select
              id="salt_mix"
              v-model="changeData.saltMix"
              class="select-control"
              @change="updateSaltConcentration"
            >
              <option value="red_sea">{{ t('waterManagement.change.saltOptions.red_sea') }}</option>
              <option value="tropic_marine">{{ t('waterManagement.change.saltOptions.tropic_marine') }}</option>
              <option value="instant_ocean">{{ t('waterManagement.change.saltOptions.instant_ocean') }}</option>
              <option value="reef_crystals">{{ t('waterManagement.change.saltOptions.reef_crystals') }}</option>
              <option value="other">{{ t('waterManagement.change.saltOptions.other') }}</option>
            </select>
          </div>
          
          <div class="form-group">
            <label for="salt_concentration">{{ t('waterManagement.change.saltConcentration') }}</label>
            <input
              type="number"
              id="salt_concentration"
              v-model="changeData.saltConcentration"
              class="form-control"
              :placeholder="t('waterManagement.volume.placeholders.saltConcentration').value"
              step="0.1"
              min="30"
              max="40"
            >
          </div>
        </div>
        
        <div class="form-section">
          <h4>{{ t('waterManagement.change.frequency') }}</h4>
          <div class="radio-group">
            <label class="radio-label">
              <input
                type="radio"
                name="frequency"
                value="weekly"
                v-model="changeData.frequency"
              >
              <span class="radio-custom"></span>
              {{ t('waterManagement.change.weekly') }}
            </label>
            <label class="radio-label">
              <input
                type="radio"
                name="frequency"
                value="biweekly"
                v-model="changeData.frequency"
              >
              <span class="radio-custom"></span>
              {{ t('waterManagement.change.biweekly') }}
            </label>
            <label class="radio-label">
              <input
                type="radio"
                name="frequency"
                value="monthly"
                v-model="changeData.frequency"
              >
              <span class="radio-custom"></span>
              {{ t('waterManagement.change.monthly') }}
            </label>
          </div>
        </div>
        
        <button
          class="calculate-btn"
          @click="calculateWaterChange"
          :disabled="!canCalculateChange"
        >
          {{ t('waterManagement.change.calculateChange') }}
        </button>
      </div>
      
      <!-- 体积计算结果 -->
      <div v-if="volumeResults.show" class="results-section">
        <div class="results-card">
          <h4>{{ t('waterManagement.volume.results.title') }}</h4>
          
          <div class="result-grid">
            <div class="result-item">
              <span class="result-label">{{ t('waterManagement.volume.results.totalVolume') }}:</span>
              <span class="result-value">{{ volumeResults.totalVolume }} L</span>
            </div>
            <div class="result-item">
              <span class="result-label">{{ t('waterManagement.volume.results.actualVolume') }}:</span>
              <span class="result-value">{{ volumeResults.actualVolume }} L</span>
            </div>
            <div class="result-item">
              <span class="result-label">{{ t('waterManagement.volume.results.effectiveVolume') }}:</span>
              <span class="result-value">{{ volumeResults.effectiveVolume }} L</span>
            </div>
            <div v-if="volumeResults.sumpVolume > 0" class="result-item">
              <span class="result-label">{{ t('waterManagement.volume.results.sumpVolume') }}:</span>
              <span class="result-value">{{ volumeResults.sumpVolume }} L</span>
            </div>
          </div>
          
          <div class="emergency-steps">
            <h5>{{ t('waterManagement.volume.results.suggestions') }}</h5>
            <ol>
              <li v-for="step in volumeResults.suggestions" :key="step">{{ step }}</li>
            </ol>
          </div>
        </div>
      </div>
      
      <!-- 换水计算结果 -->
      <div v-if="changeResults.show" class="results-section">
        <div class="results-card">
          <h4>{{ t('waterManagement.change.results.title') }}</h4>
          
          <div class="result-grid">
            <div class="result-item">
              <span class="result-label">{{ t('waterManagement.change.results.changeVolume') }}:</span>
              <span class="result-value">{{ changeResults.changeVolume }} L</span>
            </div>
            <div class="result-item">
              <span class="result-label">{{ t('waterManagement.change.results.saltAmount') }}:</span>
              <span class="result-value">{{ changeResults.saltAmount }} g</span>
            </div>
            <div class="result-item">
              <span class="result-label">{{ t('waterManagement.change.results.frequencyText') }}:</span>
              <span class="result-value">{{ changeResults.frequencyText }}</span>
            </div>
          </div>
          
          <!-- 盐度调整结果 -->
          <div v-if="changeResults.targetSaltAmount > 0 || changeResults.freshwaterAmount > 0" class="result-grid">
            <h5 style="grid-column: 1 / -1; margin-bottom: 10px; color: #2c3e50;">{{ t('waterManagement.change.results.salinityAdjustment') }}</h5>
            <div v-if="changeResults.targetSaltAmount > 0" class="result-item">
              <span class="result-label">{{ t('waterManagement.change.results.targetSaltAmount') }}:</span>
              <span class="result-value">{{ changeResults.targetSaltAmount }} g</span>
            </div>
            <div v-if="changeResults.freshwaterAmount > 0" class="result-item">
              <span class="result-label">{{ t('waterManagement.change.results.freshwaterAmount') }}:</span>
              <span class="result-value">{{ changeResults.freshwaterAmount }} L</span>
            </div>
            <div class="result-item">
              <span class="result-label">{{ t('waterManagement.change.results.finalSalinity') }}:</span>
              <span class="result-value">{{ changeResults.finalSalinity }}</span>
            </div>
          </div>
          
          <div class="emergency-steps">
            <h5>{{ t('waterManagement.change.results.steps') }}</h5>
            <ol>
              <li v-for="step in changeResults.steps" :key="step">{{ step }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useI18n } from '../composables/useI18n'

// 响应式数据
const activeTab = ref<'volume' | 'change'>('volume')
const { t } = useI18n()

// 体积计算数据
const volumeData = ref({
  length: 100,
  width: 50,
  height: 60,
  waterLevel: 55,
  hasSump: false,
  sumpLength: 60,
  sumpWidth: 40,
  sumpHeight: 40,
  sumpWaterLevel: 35,
  rockVolume: 20,
  sandVolume: 15,
  equipmentVolume: 5
})

// 换水计算数据
const changeData = ref({
  totalVolume: 200,
  currentSalinity: 1.024,
  targetSalinity: 1.025,
  changePercentage: 10,
  saltMix: 'red_sea',
  saltConcentration: 33.5,
  frequency: 'weekly' as 'weekly' | 'biweekly' | 'monthly'
})

// 计算结果
const volumeResults = ref({
  show: false,
  totalVolume: 0,
  actualVolume: 0,
  effectiveVolume: 0,
  sumpVolume: 0,
  suggestions: [] as string[]
})

const changeResults = ref({
  show: false,
  changeVolume: 0,
  saltAmount: 0,
  targetSaltAmount: 0,
  freshwaterAmount: 0,
  finalSalinity: 0,
  frequencyText: '',
  steps: [] as string[]
})

// 计算属性
const canCalculateVolume = computed(() => 
  volumeData.value.length > 0 && 
  volumeData.value.width > 0 && 
  volumeData.value.height > 0
)

const canCalculateChange = computed(() =>
  changeData.value.totalVolume > 0 &&
  changeData.value.changePercentage > 0 &&
  changeData.value.currentSalinity > 0 &&
  changeData.value.targetSalinity > 0
)

// 方法
const calculateVolume = () => {
  // 计算主缸总容积
  const mainTankTotalVolume = (volumeData.value.length * volumeData.value.width * volumeData.value.height) / 1000
  
  // 计算主缸实际水体（考虑水位）
  const mainTankActualVolume = (volumeData.value.length * volumeData.value.width * (volumeData.value.waterLevel || volumeData.value.height)) / 1000
  
  // 计算底缸体积（如果有底缸）
  let sumpVolume = 0
  if (volumeData.value.hasSump) {
    sumpVolume = (volumeData.value.sumpLength * volumeData.value.sumpWidth * volumeData.value.sumpWaterLevel) / 1000
  }
  
  // 计算总水体体积
  const totalVolume = mainTankTotalVolume + (volumeData.value.hasSump ? (volumeData.value.sumpLength * volumeData.value.sumpWidth * volumeData.value.sumpHeight) / 1000 : 0)
  const actualVolume = mainTankActualVolume + sumpVolume
  
  // 计算有效水体（减去活石、底砂、设备）
  const effectiveVolume = Math.max(0, actualVolume - volumeData.value.rockVolume - volumeData.value.sandVolume - volumeData.value.equipmentVolume)
  
  // 生成建议
  const suggestions = [
    t('waterManagement.volume.results.suggestion1').value,
    t('waterManagement.volume.results.suggestion2').value,
    t('waterManagement.volume.results.suggestion3').value
  ]
  
  if (volumeData.value.hasSump) {
    suggestions.push(t('waterManagement.volume.results.suggestion4').value)
    suggestions.push(t('waterManagement.volume.results.suggestion5').value)
  }
  
  volumeResults.value = {
    show: true,
    totalVolume: Math.round(totalVolume),
    actualVolume: Math.round(actualVolume),
    effectiveVolume: Math.round(effectiveVolume),
    sumpVolume: volumeData.value.hasSump ? Math.round(sumpVolume) : 0,
    suggestions
  }
}

// 根据海盐品牌更新浓度
const updateSaltConcentration = () => {
  const saltConcentrations: Record<string, number> = {
    red_sea: 33.5,      // 红海盐
    tropic_marine: 33.0, // TM盐
    instant_ocean: 35.5, // 美红盐
    reef_crystals: 34.0, // 法红盐
    other: 35.0         // 其他品牌
  }
  
  changeData.value.saltConcentration = saltConcentrations[changeData.value.saltMix] || 35.0
}

const calculateWaterChange = () => {
  // 计算换水量
  const changeVolume = (changeData.value.totalVolume * changeData.value.changePercentage) / 100
  
  // 计算海盐用量
  const saltAmount = Math.round(changeVolume * changeData.value.saltConcentration)
  
  // 计算目标盐度调整
  const currentSalinity = changeData.value.currentSalinity
  const targetSalinity = changeData.value.targetSalinity
  const totalVolume = changeData.value.totalVolume
  
  let targetSaltAmount = 0
  let freshwaterAmount = 0
  let finalSalinity = currentSalinity
  
  // 如果需要调整盐度
  if (Math.abs(currentSalinity - targetSalinity) > 0.001) {
    if (targetSalinity > currentSalinity) {
      // 需要加盐提高盐度
      // 计算需要增加的盐度差对应的盐量
      const salinityDifference = targetSalinity - currentSalinity
      // 将比重差转换为盐度 (ppt)，近似公式：1.000 SG ≈ 10 ppt
      const pptDifference = salinityDifference * 1000 / 100
      targetSaltAmount = Math.round(totalVolume * pptDifference)
      
      // 计算最终盐度
      const addedSalt = targetSaltAmount / totalVolume / 100
      finalSalinity = currentSalinity + addedSalt
    } else {
      // 需要加淡水降低盐度
      // 计算需要添加的淡水量
      const salinityRatio = currentSalinity / targetSalinity
      freshwaterAmount = Math.round(totalVolume * (salinityRatio - 1))
      
      // 计算最终盐度
      finalSalinity = (currentSalinity * totalVolume) / (totalVolume + freshwaterAmount)
    }
  }
  
  // 确定频率文本
  const frequencyText = t(`waterManagement.change.${changeData.value.frequency}`).value
  
  // 生成换水步骤
  const steps = [
    t('waterManagement.change.results.step1').value,
    t('waterManagement.change.results.step2', { concentration: changeData.value.saltConcentration }).value,
    t('waterManagement.change.results.step3').value,
    t('waterManagement.change.results.step4').value,
    t('waterManagement.change.results.step5').value,
    t('waterManagement.change.results.step6').value,
    t('waterManagement.change.results.step7').value
  ]
  
  // 如果需要调整盐度，添加相应步骤
  if (targetSaltAmount > 0) {
    steps.splice(5, 0, t('waterManagement.change.results.additionalSaltStep', { amount: targetSaltAmount, target: targetSalinity }).value)
  } else if (freshwaterAmount > 0) {
    steps.splice(5, 0, t('waterManagement.change.results.additionalFreshwaterStep', { amount: freshwaterAmount, target: targetSalinity }).value)
  }
  
  changeResults.value = {
    show: true,
    changeVolume: Math.round(changeVolume),
    saltAmount,
    targetSaltAmount,
    freshwaterAmount,
    finalSalinity: Math.round(finalSalinity * 1000) / 1000,
    frequencyText,
    steps
  }
}
</script>

<style scoped>
/* 组件特定样式 */
.calculator-tabs {
  display: flex;
  background: #f8f9fa;
  border-radius: 8px;
  padding: 4px;
  margin-bottom: 20px;
}

.tab-btn {
  flex: 1;
  padding: 12px 16px;
  border: none;
  background: transparent;
  border-radius: 6px;
  font-size: 0.95rem;
  font-weight: 500;
  color: #6c757d;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
}

/* 底缸部分样式 */
.sump-section {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 15px;
  margin-top: 10px;
  border-left: 4px solid #3498db;
}

/* 应急步骤样式 */
.emergency-steps {
  margin-top: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #3498db;
}

.emergency-steps h5 {
  margin: 0 0 12px 0;
  color: #2c3e50;
  font-size: 1.1em;
  font-weight: 600;
}

.emergency-steps ol {
  margin: 0;
  padding-left: 20px;
}

.emergency-steps li {
  margin-bottom: 8px;
  color: #495057;
  line-height: 1.4;
}

.emergency-steps li:last-child {
  margin-bottom: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .calculator-tabs {
    flex-direction: row;
    gap: 5px;
    overflow-x: auto;
    padding: 4px;
  }
  
  .tab-btn {
    text-align: center;
    padding: 10px 12px;
    white-space: nowrap;
    flex-shrink: 0;
    min-width: 80px;
  }
  
  .sump-section {
    padding: 12px;
  }
  
  .emergency-steps {
    padding: 12px;
  }
}
</style>